import { buildApiUrl, API_CONFIG } from './api-config';

export interface BetaApplicationData {
  email: string;
  first_name: string;
  last_name: string;
  job_title: string;
  company_name: string;
  use_for: string[];
  status_of_project: string[];
  engine: string[];
}

export interface BetaApplicationResponse {
  success: boolean;
  data?: {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    job_title: string;
    company_name: string;
    use_for: string[];
    status_of_project: string[];
    engine: string[];
    created_at: string;
  };
  error?: string;
  message?: string;
}

export const submitBetaApplication = async (
  applicationData: BetaApplicationData
): Promise<BetaApplicationResponse> => {
  try {
    const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.BETA.APPLY), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(applicationData),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.error || 'Failed to submit beta application',
        message: data.message || 'An error occurred while submitting your application',
      };
    }

    return data;
  } catch (error) {
    console.error('Error submitting beta application:', error);
    return {
      success: false,
      error: 'Network error',
      message: 'Failed to connect to the server. Please try again.',
    };
  }
};
